import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'
import gql from 'graphql-tag'

import * as fragments from '../fragments'

const DOC = gql`
  ${fragments.orgAssignment.DOC}
  query OrganizationAssignment(
    $tenantId: ID!
    $zoneId: ID!
    $appId: ID!
    $scenarioId: ID!
    $spaceRecordId: ID!
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        app(id: $appId) {
          scenario(id: $scenarioId) {
            extra {
              space {
                organizationAssignment(spaceRecordId: $spaceRecordId) {
                  ...FragmentOrganizationAssignment
                }
              }
            }
          }
        }
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.pipe(
  graphql.transformers.OUT.select<
    graphql.schema.OrganizationAssignmentQuery,
    ents.extra.space.Record.OrganizationAssignment,
    'tenant'
  >(
    'tenant',
    graphql.transformers.OUT.select(
      'zone',
      graphql.transformers.OUT.select(
        'app',
        graphql.transformers.OUT.select(
          'scenario',
          graphql.transformers.OUT.select(
            'extra',
            graphql.transformers.OUT.select(
              'space',
              graphql.transformers.OUT.select(
                'organizationAssignment',
                fragments.orgAssignment.TRANSFORMER,
              ),
            ),
          ),
        ),
      ),
    ),
  ),
  graphql.transformers.OUT.custom(assignment =>
    assignment ? [assignment] : [],
  ),
)

export const executor = graphql.createExecutor<
  graphql.schema.OrganizationAssignmentQuery,
  ents.extra.space.Record.OrganizationAssignment[],
  graphql.schema.OrganizationAssignmentQueryVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
